import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { ButtonGroup } from '../Button';
import { polyfill } from 'react-lifecycles-compat';
import { isFunction } from '@utiljs/is';
import classnames from 'classnames';
import CheckBoxButton from './CheckBoxButton';

var CheckBoxButtonGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckBoxButtonGroup, _React$Component);

  var _super = _createSuper(CheckBoxButtonGroup);

  function CheckBoxButtonGroup() {
    var _this;

    _classCallCheck(this, CheckBoxButtonGroup);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
    };

    _this.handleClick = function (value) {
      var propsValue = _this.props.value;
      var selectValue = _this.state.value;

      if (selectValue.includes(value)) {
        selectValue.splice(selectValue.indexOf(value), 1);
      } else {
        selectValue.push(value);
      }

      if (propsValue !== undefined) {
        _this.handleChange(selectValue);

        return;
      }

      _this.setState({
        value: selectValue
      }, function () {
        _this.handleChange(selectValue);
      });
    };

    _this.handleChange = function (v) {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange(v);
      }
    };

    return _this;
  }

  _createClass(CheckBoxButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          children = _a.children,
          onChange = _a.onChange,
          groupDisabled = _a.disabled,
          value = _a.value,
          defaultValue = _a.defaultValue,
          className = _a.className,
          otherProps = __rest(_a, ["children", "onChange", "disabled", "value", "defaultValue", "className"]);

      return /*#__PURE__*/React.createElement(ButtonGroup, _Object$assign({}, otherProps, {
        className: classnames('roo-btn-radio-group', className)
      }), React.Children.map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            curDisabled = _child$props.disabled;
        var disabled = curDisabled ? curDisabled : groupDisabled;
        return /*#__PURE__*/React.cloneElement(child, {
          disabled: disabled,
          checked: _this2.state.value.includes(value),
          onClick: function onClick() {
            _this2.handleClick(value);
          }
        });
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps && nextProps.value !== undefined) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return CheckBoxButtonGroup;
}(React.Component);

CheckBoxButtonGroup.rooName = 'RCheckBoxButtonGroup';
CheckBoxButtonGroup.propTypes = {
  defaultValue: PropTypes.array,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
CheckBoxButtonGroup.defaultProps = {
  defaultValue: [],
  disabled: false,
  className: '',
  onChange: undefined
};
polyfill(CheckBoxButtonGroup);
CheckBoxButtonGroup.Button = CheckBoxButton;
export default CheckBoxButtonGroup;